
Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.Card = function () {

    this.createGoToRouteDetails = function (routeView) {

        var link = document.createElement("a");
        link.setAttribute("class", "go-to-routedetail");

        var route = routeView.route;
        if (route) {
            var routeId = route.id;
            link.setAttribute("href", "#/maps/route/" + routeId + "/details");
        } else {
            link.setAttribute("href", "#");
        }

        var container = document.createElement("div");
        container.appendChild(link);

        return container;
    };

    this.getStatus = function (routeView) {

        var status = document.createElement("div");
        status.setAttribute("class", "routeMonitorRouteItem CardStatus");
        status.innerHTML = "";

        var route = routeView.route;
        if (route) {
            var routeProgressBar = new Greenmile.Components.RouteProgressBar();
            status.appendChild(routeProgressBar.createIconByRouteStatus(routeView));
        }

        return status;
    };

    this.buildDate = function (routeView, mask) {

        var date = "";
        if (routeView.route) {
            date = routeView.route.date;
        }

        if (!mask) {
            mask = "YYYY-MM-DD";
        }

        var _date = moment(date, mask);

        var dateContainer = document.createElement("div");
        dateContainer.setAttribute('class', 'date');

        var num = document.createElement("div");
        num.setAttribute('class', 'number');

        var text = document.createElement("div");
        text.setAttribute('class', 'text');

        if (_date) {
            num.textContent = _date.format("ddd");
            text.textContent = _date.format("MMM");
        }

        dateContainer.appendChild(num);
        dateContainer.appendChild(text);

        return dateContainer;
    };


};